var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-modal',{class:{ 'big-popup': true, 'is-hidden': _vm.isHidden },attrs:{"size":"lg"},on:{"close":_vm.handleClose}},[_c('d-modal-header',[_c('d-modal-title',{staticClass:"w-100"},[_vm._v(" Kartony z HPL ")])],1),_c('d-modal-body',[_c('order-boxes-list',{ref:"order-boxes-list",attrs:{"boxes-list":_vm.boxesLits,"is-on-dashboard":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }